import { useState, useEffect, useCallback } from 'react';
import { countriesService } from '../services/countriesService';
import { useAuth } from '@/features/auth/hooks/useAuth';
import type { CountryOption } from '../types/admin.types';

export const useCountries = () => {
  const { getAccessToken } = useAuth();
  const [countries, setCountries] = useState<CountryOption[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadCountries = useCallback(async () => {
    setIsLoading(true);
    try {
      const token = await getAccessToken();
      if (!token) return;
      setCountries(await countriesService.getCountries(token));
    } catch {
      setError('Failed to load countries.');
    } finally {
      setIsLoading(false);
    }
  }, [getAccessToken]);

  useEffect(() => {
    loadCountries();
  }, [loadCountries]);

  const getCountryName = (id?: number) =>
    countries.find((c) => c.country_id === id)?.name ?? '—';

  return { countries, isLoading, error, getCountryName };
};
